import { environment } from './environments/environment';

/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appBrowserConfig } from './app/app.config.browser';
import { AppComponent } from './app/app.component';

function browserSupportsAllFeatures(): any {
  return window['Intl'] && document.head['animate'];
}

function loadScript(src, done): void {
  const js = document.createElement('script');
  js.src = src;
  js.type = 'text/javascript';
  js.crossOrigin = 'anonymous';
  js.onload = (): void => {
    js.onload = null;
    done();
  };
  js.onerror = (): void => {
    done(new Error('Failed to load script ' + src));
  };
  document.head.appendChild(js);
}
// identifico se il browser supporta webp. Da utilizzare nelle background-images
// https://css-tricks.com/using-webp-images/
// document.documentElement.classList.add(canUseWebp() ? 'webp' : 'no-webp');

const bootstrap = () => bootstrapApplication(AppComponent, appBrowserConfig).catch((err) => console.error(err));
// setTimeout(bootstrap);

// platformBrowserDynamic().bootstrapModule(AppBrowserModule)
//   .then(moduleRef => {
//     const applicationRef = moduleRef.injector.get(ApplicationRef);
//     const componentRef = applicationRef.components[0];
//     enableDebugTools(componentRef);
//   })
//   .catch(err => console.error(err));

document.addEventListener('DOMContentLoaded', () => {
  if (browserSupportsAllFeatures()) {
    // ultimo aggiornamento per il polyfills
    // https://github.com/angular/angular-cli/pull/13403
    // devo guardarci bene.
    // inizialmente l'idea nasce da qui:
    // https://github.com/angular/angular-cli/issues/6577#issuecomment-457566648

    // Browsers that support all features run `main()` immediately.
    bootstrap();
  } else {
    // All other browsers loads polyfills and then run `main()`.
    loadScript('https://cdn.polyfill.io/v3/polyfill.min.js?features=es6,Element.prototype.classList,WebAnimations,Intl.~locale.en',
      () => {
        bootstrap();
      });
  }
});

